export default "__VITE_ASSET__C2W8jF5S__"